<template>
    <div class="modal right fade trader-info c-offer-modal" id="trader-info" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">BA BIDS - {{ bidwanted }}</h5>
            <div class="float-right">
              <button type="button" class="close" @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
           
          </div>
          <div class="modal-body">
            <div class="row xsOnly">
                <div class="table-responsive">
                    <div v-if="loading" class="loader">
                    <img src="@/assets/img/loader.svg" alt="" />
                    </div>
                    <table
                    class="table align-items-center table-flush table-hover bidtbl"
                    style="min-height: 125px"
                    >
                    <thead class="thead-light psticky">
                        <tr>
                        <th scope="col" class="sort text-center">Date</th>
                        <th scope="col" class="sort text-center">ecn</th>
                        <th scope="col" class="sort text-center">sell Quantity</th>
                        <th scope="col" class="sort text-center">highbid price</th>
                        </tr>
                    </thead>
                    <tbody class="list no-cursor">
                        <tr v-if="bidwantedList.length == 0 && !loading">
                        <td><p class="nodata">No data available</p></td>
                        </tr>
                        <tr v-for="(data, indexBid) in bidwantedList" :key="indexBid">
                        <td class="text-center">
                            {{
                            data.createdAt
                                ? moment(data.createdAt).format("MM/DD/YYYY")
                                : "N/A"
                            }}
                        </td>
                        <td class="text-center">{{ data.ecn }}</td>
                        <td class="text-center">{{ data.sellQuantity }}</td>
                        <td class="text-center">
                            {{ data.highBidPrice | currency }}
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import config from "@/config";
  import authService from "@/authService";

  export default {
    name: 'sendBidModal',
    components: {
     
    },
    props: ["bidwanted"],
    data() {
      return {
        bidwantedList : [],
        loading : false
      };
    },
    methods: {
    getBidwantedList() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/bidwanted-available-in-range?cusip="+this.bidwanted+"&cognitoSub="+authService.getUser().cognitoSub,
          auth
        )
        .then((result) => {
            this.bidwantedList = result.data;
            this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
  
    },
    mounted() {
      this.getBidwantedList();
    }

  };
  </script>